import styled from 'styled-components';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

// Assets
import ErrorIcon from '../../public/assets/icons/common/error.svg';

// Components
import Button from '../ui/Button';
import router from 'next/router';

const ErrorComponent = () => {
  const { t } = useTranslation('common');
  return (
    <ErrorContainer>
      <Image
        src={ErrorIcon}
        alt="errorIcon"
        width={142}
        height={165}
        sizes="50vw"
        priority
      />
      <h1>{t('error_main_header')}</h1>
      <p>{t('error_sub_header')}</p>
      <Button
        backgroundColor=""
        border="none"
        color=""
        fontSize=""
        text={t('return_home')}
        onClick={() => {
          router.push({
            pathname: '/'
          });
        }}
        padding="0px 0px"
        btnClass="error-btn"
      />
    </ErrorContainer>
  );
};

const ErrorContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h1 {
    color: #00324c;
    font-size: 24px;
    font-family: materialBold;
    margin-top: 21px;
    margin-bottom: 4px;
    @media screen and (max-width: ${props =>
        props.theme.breakPoints.tablet.max}) {
      font-size: ${props => props.theme.font.sizes.xl};
    }
  }
  p {
    font-size: ${props => props.theme.font.sizes.l};
    color: #212427;
    font-family: materialLight;
    margin-bottom: 8px;
    @media screen and (max-width: ${props =>
        props.theme.breakPoints.tablet.max}) {
      font-size: ${props => props.theme.font.sizes.s};
    }
  }
  .error-btn {
    background: ${props => props.theme.light.colors.primaryBlue};
    border-radius: ${props => props.theme.borderRadius};
    border: none;
    width: 162px;
    height: 40px;
    color: ${props => props.theme.light.colors.white};
    font-family: materialMedium;
    font-size: ${props => props.theme.font.sizes.l};
    @media only screen and (min-width: ${props =>
        props.theme.breakPoints.desktop.min}) {
      &:hover {
        background: ${props => props.theme.light.hoverColors.primaryBlue};
      }
    }
    @media screen and (max-width: ${props =>
        props.theme.breakPoints.tablet.max}) {
      width: 143.13px;
    }
  }
`;
export default ErrorComponent;
